var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload Log List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "innerTableHeader": _vm.innerTableColumn,
      "isEditHidden": true,
      "offset": _vm.offset,
      "items": _vm.tableItems
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [(_vm.filetypedisplay == 2) ? _c('b-card', [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Display Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Failed Reason")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.viewuploadlogListexcel), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.status == 0),
        expression: "data.status == 0"
      }],
      staticClass: "text-center"
    }, [_vm._v("Failed")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.status == 1),
        expression: "data.status == 1"
      }],
      staticClass: "text-center"
    }, [_vm._v("Success")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewuploadlogListexcel.length == 0),
      expression: "viewuploadlogListexcel.length==0"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No record.")])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.filetypedisplay == 1) ? _c('b-card', [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Failed Reason")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.viewuploadlogListcsv), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.isvalid == 0),
        expression: "data.isvalid == 0"
      }],
      staticClass: "text-center"
    }, [_vm._v("Failed")]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.isvalid == 1),
        expression: "data.isvalid == 1"
      }],
      staticClass: "text-center"
    }, [_vm._v("Success")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewuploadlogListcsv.length == 0),
      expression: "viewuploadlogListcsv.length==0"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No record.")])])], 2)])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1bad96","hasScoped":true}!./src/modules/cargobooking/views/booking/Uploadloglist/Uploadloglist.component.html
// module id = 1220
// module chunks = 3